import { render, staticRenderFns } from "./login-account.vue?vue&type=template&id=5c7007f9&scoped=true&"
import script from "./login-account.vue?vue&type=script&lang=js&"
export * from "./login-account.vue?vue&type=script&lang=js&"
import style0 from "./login-account.vue?vue&type=style&index=0&id=5c7007f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7007f9",
  null
  
)

export default component.exports